import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from "../router";

Vue.use(Vuex)
// const resourceHost = 'https://stapi.carrotenglish.net'
const enhanceAccessToeken = () => {
  const {accessToken} = localStorage
  if (!accessToken) return
  axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
}
enhanceAccessToeken()
export default new Vuex.Store({
  state: {
    accessToken: null,
    host:"https://stapi.carrotenglish.net"
  },
  mutations: {
    loginCheck:function(state){
      // var params = state;
      var params = {};
      params.uidx = localStorage.getItem("uidx");
      params.accessToken = localStorage.getItem("accessToken");
      // console.log(params);
      console.log(localStorage.getItem("accessToken"));
      
      axios.get(`${state.host}/rest/common/chkMemberToken`,{params:params}).then(
        res=>{
          // console.log(res);
          if(res.data.err == 0){
            console.log(res);
          }else{
            alert(res.data.err_msg);
            router.push("/login");
          }
        },
        error=>{
          console.log(error);
          // router.push("/login");
        }
      )
    },
    LOGIN (state, {accessToken}) {
      state.accessToken = accessToken
      localStorage.accessToken = accessToken
    },
    LOGOUT (state) {
      state.accessToken = null
      localStorage.accessToken = null;
      localStorage.setItem("accessToken",null);

    },
    changeHost(state, host) { 
      state.host = host; // state의 account변수에 넘겨 받은 account값을 입력함 
    }
  },
  actions: {
    LOGIN ({commit}, {email, password}) {
      return axios.post(`${this.state.host}/rest/common/new_login`, {email, password})
        .then(({data}) => {
          if(data.err == 0){
            // localStorage.clear();
            localStorage.setItem("accessToken","");
            localStorage.setItem("accessKey","");
            localStorage.setItem("uidx","");
            localStorage.setItem("kname","");
            localStorage.setItem("ename","");
            commit('LOGIN', data.token);
            localStorage.setItem("accessToken",data.token);
            localStorage.setItem("accessKey",data.accessKey);
            localStorage.setItem("uidx",data.uidx);
            localStorage.setItem("kname",data.kname);
            localStorage.setItem("ename",data.ename);
            localStorage.setItem("email",data.ename);
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
            router.push("/intro");
            localStorage.setItem("is_lock",false);
          }else{
            alert(data.err_msg);
            localStorage.setItem("fail_cnt",data.fail_cnt);
            localStorage.setItem("is_lock",data.is_lock);
          }
         
        })
    },
    LOGOUT ({commit},{accessToken,accessKey}) {
      return axios.post(`${this.state.host}/rest/common/new_logout`, {accessToken,accessKey})
          .then(({data}) => {
            if(data.err == 0){
              alert("로그아웃 되었습니다.");
              console.log(data.del)
              commit('LOGOUT')
            }
          });
    },
  },
  modules: {
  }
})
